import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3, Vector3 } from '@babylonjs/core/Maths/math';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { Scene } from '@babylonjs/core/scene';
import { eViewpointTargetMode, eViewpointType } from '@kb3d/models/classes/enums';
import { ViewpointNode } from '@kb3d/models/classes/viewpoints';

export function createViewpointVisualization(viewpoint: ViewpointNode, scene: Scene, color?: Color3) {
    if (!color) {
        color = Color3.Green();
    }
    let targetPositionMarker: Mesh | undefined;

    const viewpointPositionGizmo = MeshBuilder.CreateCylinder(
        'cameraGizmoLens',
        { diameterTop: 0.3, height: 0.2, diameterBottom: 0.2, tessellation: 8 },
        scene
    );
    const coloredMaterial = new StandardMaterial('', scene);
    coloredMaterial.wireframe = true;
    coloredMaterial.emissiveColor = color;
    viewpointPositionGizmo.material = coloredMaterial;

    const lightPositionGizmoBox = MeshBuilder.CreateBox('cameraGizmoBody', { size: 0.4 }, scene);
    lightPositionGizmoBox.setParent(viewpointPositionGizmo);
    lightPositionGizmoBox.position = new Vector3(0, -0.3, 0);
    lightPositionGizmoBox.material = coloredMaterial;

    viewpointPositionGizmo.isPickable = false;
    viewpointPositionGizmo.setEnabled(true);

    if (viewpoint.type === eViewpointType.orbit && viewpoint.targetMode === eViewpointTargetMode.point) {
        targetPositionMarker = MeshBuilder.CreateSphere('viewpointTargetMarker', { diameter: 0.15 }, scene);
        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.emissiveColor = color;
        targetPositionMarker.material = coloredMaterial;
        targetPositionMarker.isPickable = false;
        targetPositionMarker.setEnabled(true);
    }

    return { viewpointPositionGizmo, targetPositionMarker };
}
